/**
 * Locale preference cookie. Language only — never a token, never bootstrap JSON.
 * Host-only (no Domain); readable by the SPA (not HttpOnly).
 */
import {
  LOCALE_COOKIE_NAME,
  normalizeLocale,
  type SupportedLocale,
} from './constants';

export function readLocaleCookie(): SupportedLocale | null {
  if (typeof document === 'undefined') return null;
  const parts = document.cookie.split(';');
  for (const part of parts) {
    const trimmed = part.trim();
    const eq = trimmed.indexOf('=');
    if (eq === -1) continue;
    const name = trimmed.slice(0, eq);
    if (name !== LOCALE_COOKIE_NAME) continue;
    const raw = trimmed.slice(eq + 1);
    try {
      return normalizeLocale(decodeURIComponent(raw));
    } catch {
      return null;
    }
  }
  return null;
}

export function writeLocaleCookie(locale: SupportedLocale): void {
  if (typeof document === 'undefined') return;
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${LOCALE_COOKIE_NAME}=${locale}; Path=/; Max-Age=31536000; SameSite=Lax${secure}`;
}
